module.exports = __webpack_public_path__ + "img/pic_top@2x.059dd72b.png";